import React from 'react'
import { MemberPill } from '../components/tasks/chips/MemberPill.jsx'

/**
 * Author pill for agenda items. Thin shim that delegates to the shared
 * <MemberPill> so agenda and tasks share the same initials-avatar +
 * "Me" replacement visual.
 *
 * Keeps its phase-1 prop shape (`addedBy`, `currentUserId`,
 * `otherUserName`) so the agenda call site doesn't need to change.
 */
export function AuthorPill({ addedBy, currentUserId, otherUserName }) {
  if (!addedBy) return null
  const isMe = addedBy === currentUserId
  if (!isMe && !otherUserName) return null
  return (
    <MemberPill
      userId={addedBy}
      displayName={isMe ? null : otherUserName}
      currentUserId={currentUserId}
      variant="agenda"
      ariaLabelPrefix="Author"
    />
  )
}
